import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { Router } from '@angular/router';
import { tap } from 'rxjs/operators';
import { HttpService } from './http.service';
import { AuthInfo, RegistrationRequest, UserAuth, UserInfo } from '../type/auth.interface';
import { DictionaryService } from './dictionary.service';
import { environment } from '../../environments/environment';
import { NzModalService } from 'ng-zorro-antd/modal';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private tokenAccess: string;
  private timeActualTokens: null | Date;
  private infoUser: AuthInfo;
  public nameOrg = '';

  isAuthenticated$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private userFirstName: string;
  private userMidName: any;
  private userBirthDate: any;
  private userLastName: any;
  private fio: string;
  public cardNumber: number;
  public userId: number;
  public name$ = new BehaviorSubject<string>('');

  get token(): string | null {
    // @ts-ignore
    const dateActual = new Date(localStorage.getItem('time_actual_tokens'));

    if (!dateActual && new Date() > dateActual) { // TODO new Date() > dateActual при каждом запросе проверка
      // console.log('time_actual_tokens');
      // this.logout(); // TODO выход только если нажал, а так получение другого токена при попытке перейти на другой урл
      return null;
    }
    return localStorage.getItem('token_access');
  }

  constructor(private http: HttpClient,
              private router: Router,
              private httpService: HttpService,
              private modalService: NzModalService,
              private dictionaryService: DictionaryService) {
  }


  login(data: RegistrationRequest): Observable<AuthInfo> {

    return this.http.post<AuthInfo>(environment.apiUrl + 'convicted/login', data).pipe(
      // @ts-ignore
      tap(e => {
        this.infoUser = e;
        return this.setToken(e);
      })
    );
  }

  registration(data: RegistrationRequest): Observable<AuthInfo> {
    return this.http.post<AuthInfo>(environment.apiUrl + 'convicted/register', data).pipe(
      tap(e => {
        this.infoUser = e;
        return this.setToken(e);
      })
    );
  }

  info() {
    return this.httpService.getInfo().pipe(tap(x => {
      this.setInfo(x);
    }));
  }

  logout() {
    this.setToken(null);
    this.isAuthenticated();
    this.dictionaryService.reset();
    this.modalService.closeAll();
    this.router.navigate(['/login']);
  }

  isAuthenticated(): boolean {
    console.log(this);
    this.isAuthenticated$.next(!!this.token);
    this.dictionaryService.isAccess = !!this.token;
    return !!this.token;
  }

  checkAuth() {
    if (!this.isAuthenticated$.value) {
      if (!this.isAuthenticated()) {
        this.router.navigateByUrl('login');
      }
    }
  }
  /*isAccessCardsNaming(): boolean {
    // console.log('isAuthenticated CH');
    this.checkAuth();
    const access = this.accessCardsNaming || localStorage.getItem('access_cards_naming')
    if (access === null) {
      return false;
    }
    return !!access;
  }*/


  setInfo(response: UserInfo) {
    this.userId = response.ConvictedID;
    /*if (response.ConvictedFirstName && response.ConvictedLastName) {
      this.userFirstName = response.ConvictedFirstName;
      this.userMidName = response.ConvictedMidName;
      this.userLastName = response.ConvictedLastName;

    }*/
    const fioArr = response.ConvictedName.split(' ');
    this.userFirstName = response.ConvictedName;
    this.userBirthDate = response.ConvictedBirthDate;
    this.fio = response.ConvictedName;
    this.cardNumber = response.CardNumber;
    this.name$.next(response.ConvictedName);
  }

  private setToken(response: AuthInfo | null) {
    if (response) {
      this.timeActualTokens = new Date(new Date().getTime() + 300000);
      this.tokenAccess = response.access_token;
      this.setInfo(response.convicted);
      localStorage.setItem('time_actual_tokens', this.tokenAccess);
      localStorage.setItem('token_access', this.tokenAccess);
      this.dictionaryService.init();
    } else {
      localStorage.clear();
      this.timeActualTokens = null;
      this.nameOrg = '';
      this.tokenAccess = '';
    }
  }
  sendRequest(data: any) {
    if (environment.production) {
      return this.http.post<any>('https://lko.svoya-svyaz.ru/api/feedback/', data);
    }
    return this.http.post<any>('https://lko-test.svoya-svyaz.ru/api/feedback/', data);

  }
}
